import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useState } from 'react';
import SpinnerApple from "../ui/spinner/Spinner.Apple";
import { __convert_byte } from "noood/util/converters/converters";
import FlexJustified from "noood/comp/ui/containers/flex-boxes/FlexJustified";
import BlockDiv from "noood/comp/ui/containers/BlockDiv";
import Div from "noood/comp/ui/containers/Div";
import Tag from "noood/comp/ui/tag/Tag";
import Spacer from "noood/comp/ui/spacer/Spacer";
import * as stylex from '@stylexjs/stylex';
import Icon from "noood/comp/ui/feather-icon/Icon";
import { UploadProgressContext } from "noood/contexts/contexts";
import { decryptPayloadHybridRSA } from "noood/net/xhr";
export var UploadProgressContextProvider = function UploadProgressContextProvider(_ref) {
  var children = _ref.children;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    upload_entities = _useState2[0],
    set_upload_entities = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    uploading_count = _useState4[0],
    set_uploading_count = _useState4[1];
  useEffect(function () {
    // let uploading = upload_entities.filter(f => f.status === 'uploading').length;
    // if (uploading > 0 && upload_entities.length > 0) {
    //   let pending = upload_entities.filter(f => f.status === 'pending');
    //   let some_id = [...pending][0];
    //   let index_of_some_id = upload_entities.findIndex(f => f.id === {...some_id}.id);
    //   let entities = [...upload_entities];
    //   let entity_for_upload = {...entities[index_of_some_id], ...{status: 'uploading'}};
    //   __upload(entity_for_upload);
    //   entities[index_of_some_id] = entity_for_upload;
    //   set_upload_entities(entities);
    // }
    if (upload_entities.length > 0) {
      var first_pending = upload_entities.find(function (f) {
        return f.status === 'pending';
      });
      __upload(first_pending);
    }
  }, [upload_entities.length]);
  useEffect(function () {
    if (upload_entities.length > 0) {
      var pending = upload_entities.filter(function (f) {
        return f.status === 'pending';
      });
      if (pending && pending.length > 0) {
        console.log('the pending uploads changed, i will upload the next');
        __upload(pending[0]);
      }
    }
  }, [upload_entities.filter(function (f) {
    return f.status === 'successful' || f.status === 'error';
  }).length]);
  var __register_file = function __register_file(upload_entity) {
    set_upload_entities([].concat(_toConsumableArray(upload_entities), [upload_entity]));
  };
  var __register_files = function __register_files(new_upload_entities) {
    set_upload_entities([].concat(_toConsumableArray(upload_entities !== null && upload_entities !== void 0 ? upload_entities : []), _toConsumableArray(new_upload_entities !== null && new_upload_entities !== void 0 ? new_upload_entities : [])));
  };
  var __count_uploading = function __count_uploading() {
    return upload_entities.filter(function (file) {
      return file.props.file.status === 'uploading';
    }).length;
  };
  var __count_status = function __count_status(status) {
    console.log(upload_entities);
    return upload_entities.filter(function (file) {
      return file.status === status;
    }).length;
  };
  function __update_list(file_id, mutator) {
    var index_of_some_id = upload_entities.findIndex(function (f) {
      return f.id === file_id;
    });
    var entities = _toConsumableArray(upload_entities);
    var file_at_index = entities[index_of_some_id];
    entities[index_of_some_id] = _objectSpread(_objectSpread({}, file_at_index), mutator);
    set_upload_entities(entities);
  }
  var __decryptable = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(responseText) {
      var rawJson, errorPayload, response, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            rawJson = responseText;
            errorPayload = {
              http: {
                code: 500,
                message: "Internal Server Error"
              },
              error: ['Something went wrong']
            };
            if (!(process.env.__PAYLOAD_IS_ENCRYPTED === 'true')) {
              _context.n = 4;
              break;
            }
            _context.p = 1;
            _context.n = 2;
            return decryptPayloadHybridRSA(typeof rawJson === 'string' ? JSON.parse(rawJson) : rawJson);
          case 2:
            response = _context.v;
            return _context.a(2, response);
          case 3:
            _context.p = 3;
            _t = _context.v;
            return _context.a(2, errorPayload);
          case 4:
            _context.p = 4;
            return _context.a(2, typeof rawJson === 'string' ? JSON.parse(rawJson) : rawJson);
          case 5:
            _context.p = 5;
            _t2 = _context.v;
            return _context.a(2, errorPayload);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[4, 5], [1, 3]]);
    }));
    return function __decryptable(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  function __upload(_x2) {
    return _upload.apply(this, arguments);
  }
  function _upload() {
    _upload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(file) {
      var request, form_data;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            // console.log(file);
            request = new XMLHttpRequest();
            request.open('POST', process.env.API + '/doc', true);
            request.setRequestHeader("Authorization", "Bearer " + localStorage.getItem(process.env.TOKEN_KEY));
            request.withCredentials = true;
            if (process.env.TOKEN_KEY) {
              request.setRequestHeader("x-token-key", process.env.TOKEN_KEY);
            }
            if (process.env.TOKEN_REFRESH_KEY) {
              request.setRequestHeader("x-token-refresh-key", process.env.TOKEN_REFRESH_KEY);
            }
            request.upload.addEventListener("progress", function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = Math.round(100 * (100 * (evt.loaded / evt.total))) / 100;
                if (percentComplete >= 100) {
                  __update_list(file.id, {
                    percent_complete: 100,
                    uploaded: file.file.size,
                    status: 'processing'
                  });
                } else {
                  __update_list(file.id, {
                    percent_complete: percentComplete,
                    uploaded: evt.loaded,
                    status: 'uploading'
                  });
                }
              }
            }, false);
            request.onreadystatechange = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
              var response, _t3;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    if (!(request.readyState === 4)) {
                      _context2.n = 4;
                      break;
                    }
                    if (!(request.status > 199 && request.status < 300)) {
                      _context2.n = 2;
                      break;
                    }
                    __update_list(file.id, {
                      status: 'successful',
                      percent_complete: 100,
                      uploaded: file.file.size
                    });
                    // get the response text and reply this to the calling component
                    // check also if the payloads are encrypted
                    _t3 = file;
                    _context2.n = 1;
                    return __decryptable(request.responseText);
                  case 1:
                    _t3.callback.call(_t3, _context2.v);
                    _context2.n = 4;
                    break;
                  case 2:
                    _context2.n = 3;
                    return __decryptable(request.responseText);
                  case 3:
                    response = _context2.v;
                    console.log("response2: ", response);
                    __update_list(file.id, {
                      status: 'error',
                      apiResponse: response
                    });
                  case 4:
                    return _context2.a(2);
                }
              }, _callee2);
            }));
            form_data = new FormData();
            form_data.append('file', file.file);
            form_data.append('entity_type', file.entity_type);
            form_data.append("extra_payload", JSON.stringify(file.extra_payload));
            request.send(form_data);
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _upload.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UploadProgressContext.Provider, {
    value: {
      __register_file: __register_file,
      __count_uploading: __count_uploading,
      __register_files: __register_files
    }
  }, upload_entities.length > 0 ? /*#__PURE__*/React.createElement("div", _extends({}, {
    className: "UploadProgressContext__ui.base ev1u8a7rm evixxii4 evjnlgov ev1c42kn3 ev18n5i07 evw5ewwj ev1ye9jal ev1710852"
  }, {
    style: {
      borderRadius: 'var(--roundness)',
      overflow: "hidden"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '10px',
      fontSize: '13px',
      backgroundColor: "var(--shade-darkest)",
      color: "var(--shade-70)"
    }
  }, /*#__PURE__*/React.createElement(FlexJustified, null, /*#__PURE__*/React.createElement(BlockDiv, null, 'Uploaded: ', upload_entities.filter(function (file) {
    return file.status === 'successful';
  }).length, ' of ', upload_entities.length), /*#__PURE__*/React.createElement(Div, null, /*#__PURE__*/React.createElement("div", _extends({}, {
    className: "UploadProgressContext__ui.closeButton ev1h2kqdt evji57aj ev6nv2ps ev1m1yct7 evorixrz ev78zum5 ev6s0dn4 evl56j7k ev9ms5i6"
  }, {
    onClick: function onClick() {
      set_upload_entities([]);
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: "x",
    size: 13
  }))))), /*#__PURE__*/React.createElement("div", {
    style: {
      maxHeight: '300px',
      overflowY: 'auto'
    }
  }, (upload_entities === null || upload_entities === void 0 ? void 0 : upload_entities.length) > 0 ? upload_entities.map(function (upload_entity, idx) {
    var _upload_entity$percen, _upload_entity$upload, _upload_entity$file$s, _upload_entity$percen2, _upload_entity$apiRes;
    return /*#__PURE__*/React.createElement("div", _extends({}, {
      className: "UploadProgressContext__ui.upload_item evj6yrti ev7z7khe ev1kw5lbn evi51yt4 ev1vf1gkk ev1ydnvkp"
    }, {
      key: idx,
      style: {
        color: "var(--shade-50)"
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "UploadProgressContext__ui.filename ev4z9k3i ev1lliihq evuxw1ft evb3r6kr evlyipyv"
    }, upload_entity.file.name), /*#__PURE__*/React.createElement(Spacer, {
      mtop: 3
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        height: '5px',
        backgroundColor: "var(--shade)",
        width: '100%',
        borderRadius: 'var(--roundness)'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: ((_upload_entity$percen = upload_entity.percent_complete) !== null && _upload_entity$percen !== void 0 ? _upload_entity$percen : '0') + '%',
        backgroundColor: 'var(--accent)',
        height: '5px',
        borderRadius: 'var(--roundness)'
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "UploadProgressContext__ui.progress_stats ev1psrgls ev1j6dyjg ev160uoy ev78zum5 ev1ok221b ev1nejdyq"
    }, ['processing', 'uploading'].indexOf(upload_entity.status) > -1 && /*#__PURE__*/React.createElement(SpinnerApple, null), upload_entity.status === 'error' && /*#__PURE__*/React.createElement(Tag, {
      value: 'ERROR',
      color: "var(--shade-negative)",
      textColor: 'var(--text-on-shade-negative)'
    }), upload_entity.status === 'successful' && /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: '10px',
        display: "flex",
        alignItems: "center",
        padding: '1px 5px',
        borderRadius: 'var(--roundness)',
        backgroundColor: '#93d578',
        color: '#000'
      },
      className: 'text-smallcaps'
    }, "Success"), upload_entity.status === 'pending' && /*#__PURE__*/React.createElement("div", null, "Pending"), /*#__PURE__*/React.createElement("div", {
      style: {
        fontFamily: 'mono'
      }
    }, __convert_byte((_upload_entity$upload = upload_entity.uploaded) !== null && _upload_entity$upload !== void 0 ? _upload_entity$upload : 0), "/", __convert_byte((_upload_entity$file$s = upload_entity.file.size) !== null && _upload_entity$file$s !== void 0 ? _upload_entity$file$s : 0)), /*#__PURE__*/React.createElement("div", null, "\xB7"), /*#__PURE__*/React.createElement("div", {
      style: {
        fontFamily: 'mono'
      }
    }, (_upload_entity$percen2 = upload_entity.percent_complete) !== null && _upload_entity$percen2 !== void 0 ? _upload_entity$percen2 : 0, "%")), ((_upload_entity$apiRes = upload_entity.apiResponse) === null || _upload_entity$apiRes === void 0 || (_upload_entity$apiRes = _upload_entity$apiRes.error) === null || _upload_entity$apiRes === void 0 ? void 0 : _upload_entity$apiRes.length) > 0 && /*#__PURE__*/React.createElement("span", {
      className: "UploadProgressContext__ui.error_msg ev17q8loj evfifm61 ev1wfe3co"
    }, upload_entity.apiResponse.error.join(". ")));
  }) : null)) : null, children));
};
_inject(".ev1u8a7rm{z-index:5}", 3000);
_inject(".evixxii4{position:fixed}", 3000);
_inject(".evjnlgov{bottom:20px}", 4000);
_inject(".ev1c42kn3{left:20px}", 4000);
_inject(".ev18n5i07{min-width:300px}", 4000);
_inject(".evw5ewwj{max-width:300px}", 4000);
_inject(".ev1ye9jal{box-shadow:0 15px 25px rgba(0,0,0,.3)}", 3000);
_inject(".ev1710852{border:1px solid var(--shade-dark)}", 1000);
_inject(".ev4z9k3i{font-size:13px}", 3000);
_inject(".ev1lliihq{display:block}", 3000);
_inject(".evuxw1ft{white-space:nowrap}", 3000);
_inject(".evb3r6kr{overflow:hidden}", 2000);
_inject(".evlyipyv{text-overflow:ellipsis}", 3000);
_inject(".ev1psrgls{font-family:\"mono\"}", 3000);
_inject(".ev1j6dyjg{font-size:11px}", 3000);
_inject(".ev160uoy{color:#aaa}", 3000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev1ok221b{margin-top:5px}", 4000);
_inject(".ev1nejdyq{gap:5px}", 2000);
_inject(".evj6yrti{background-color:var(--shade-light)}", 3000);
_inject(".ev7z7khe{padding:10px}", 1000);
_inject(".ev1kw5lbn{border-bottom:1px solid var(--shade-lighter)}", 2000);
_inject(".evi51yt4:last-of-type{border-bottom:0}", 2055);
_inject(".ev1vf1gkk:last-of-type{border-bottom-left-radius:var(--roundness)}", 4055);
_inject(".ev1ydnvkp:last-of-type{border-bottom-right-radius:var(--roundness)}", 4055);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".evji57aj{background-color:var(--shade-10)}", 3000);
_inject(".ev6nv2ps:hover{background-color:var(--shade-20)}", 3130);
_inject(".ev1m1yct7:active{background-color:var(--shade-30)}", 3170);
_inject(".evorixrz{border-radius:100%}", 2000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject(".ev9ms5i6{padding:3px}", 1000);
_inject(".ev17q8loj{color:var(--text-error)}", 3000);
_inject(".evfifm61{font-size:12px}", 3000);
_inject(".ev1wfe3co{line-height:12px}", 3000);